import { useLocation } from "react-router-dom";
import { SearchX } from "lucide-react";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header/Header";
import TitleBand from "../../components/TitleBand/TitleBand";
import ArrowButton from "../../components/ArrowButton/ArrowButton";
import ChatWidget from "../../components/ChatWidget/ChatWidget";
import Seo from "../../seo/Seo";
import "./NotFound.css";

// Rota inexistente (e post do blog que não existe). noindex para o Google não indexar o endereço.
export default function NotFound() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <div className="cz-page cz-scope cz-notfound-page">
      <Seo
        title={t("seo.not_found.title", "Página não encontrada")}
        description={t("seo.not_found.description", "A página que você procurou não existe ou mudou de endereço.")}
        path={pathname}
        noindex
      />
      <Header />
      <main>
        <TitleBand title={t("seo.not_found.title", "Página não encontrada")} icon={SearchX} />
        <section className="cz-notfound">
          <p className="cz-notfound__text">
            {t("seo.not_found.description", "A página que você procurou não existe ou mudou de endereço.")}
          </p>
          <ArrowButton to="/" variant="pink" size="lg">
            {t("seo.not_found.back", "Voltar para a página inicial")}
          </ArrowButton>
        </section>
      </main>
      <ChatWidget />
    </div>
  );
}
